import { Navigation, NavigationSport, NavigationSportGroup, NavigationSportTournament } from '@/api/validators/navigation';
import { TournamentSport, TournamentGroup, Tournament, Tournaments } from '@/components/Sport/types';

export const convertNavigation = (navigationApi: Navigation) => {
  const tours = navigationApi.map((sportApi) => ({
    label: sportApi.name,
    id: sportApi.id,
    sport: sportApi.sport,
    image: sportApi.image,
    groups: (sportApi as NavigationSport).children ?
      (sportApi as NavigationSport).children
        .filter((groupApi) => (groupApi as NavigationSportGroup).children)
        .map((groupApi) => ({
          label: groupApi.name,
          tournaments: (groupApi as NavigationSportGroup).children.map((tourApi) => ({
            label: tourApi.name,
            id: tourApi.id,
            image: tourApi.image,
            providerId: tourApi.providerId,
            legacyId: tourApi.legacyId,
            sport: tourApi.sport,
            classification: tourApi.classification,
          }) as Tournament),
        }) as TournamentGroup)
      : [],
    tournaments: (sportApi as NavigationSport).children ?
      (sportApi as NavigationSport).children
        .filter((groupApi) => !(groupApi as NavigationSportGroup).children)
        .map((tourApi) => ({
          label: tourApi.name,
          id: (tourApi as NavigationSportTournament).id,
          image: tourApi.image,
          providerId: (tourApi as NavigationSportTournament).providerId,
          legacyId: (tourApi as NavigationSportTournament).legacyId,
          sport: (tourApi as NavigationSportTournament).sport,
          classification: (tourApi as NavigationSportTournament).classification,
        }))
      : [],
  }) as TournamentSport);

  const tournaments: Tournaments = {};

  tours.forEach((tour) => {
    tournaments[tour.id] = tour;
  });

  return tournaments;
};
